import { renderRoutes } from 'react-router-config';

export default function RootPage(props){
    // 因为在非组件页面无法使用history，无法进行路由跳转。例如：axios。特此如下：
    window.$history = props.history
    window.$location = props.location
    
    return <>{renderRoutes(props.route.routes)}</>
}

